import React from 'react';
import Reveal from '../Reveal/Reveal';
import { IconShieldCheck, IconCertificate, IconGlobeLeaf } from '../Icons/Icons';
import '../../assets/css/timeline.css';

const STEPS = [
  {
    icon: IconShieldCheck,
    step: 'Step 01',
    title: 'Ofgem',
    text: 'Ofgem Compliance covering monthly and quarterly regulatory submissions.',
  },
  {
    icon: IconCertificate,
    step: 'Step 02',
    title: 'GGCS',
    text: 'Green Gas Certificate Scheme submissions and administration.',
  },
  {
    icon: IconGlobeLeaf,
    step: 'Step 03',
    title: 'ISCC',
    text: 'ISCC Compliance covering mass balance, audits and certification support.',
  },
];

function Timeline({
  eyebrow = 'Recurring Workflow',
  title = 'The Current Quarterly Chain',
  subtitle = 'A repeating cycle of regulatory work that runs every quarter for our clients.',
  steps = STEPS,
}) {
  return (
    <section className="section timeline">
      <div className="container">
        <div className="section-header">
          <Reveal direction="up">
            <span className="section-label">{eyebrow}</span>
            <h2 className="section-title">{title}</h2>
            <p className="section-subtitle">{subtitle}</p>
          </Reveal>
        </div>

        <div className="timeline-track">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <Reveal direction="up" delay={index * 120} key={step.title}>
                <div className="timeline-node">
                  <span className="timeline-node-number">
                    <Icon width={28} height={28} />
                  </span>
                  <div className="timeline-node-content">
                    <span className="timeline-step-label">{step.step}</span>
                    <h3 className="timeline-node-title">{step.title}</h3>
                    <p className="timeline-node-text">{step.text}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Timeline;
